import { httpClient } from "@coworker/http-client";
import { sanitiseDots } from "@coworker/app/src/helpers/utils";
import { CombinationProducts } from "../types/article";
import { formatCombinationNumber } from "@coworker/apprestructured/src/scan-and-search/helpers/searchUtils";
import { LocalCombinationItem } from "@coworker/apprestructured/src/shared/types/localCombinationItem";

export const searchCombinationNameOrId = async (
  storeId: string,
  text: string
) => {
  try {
    return await httpClient.data.post<CombinationProducts[]>(
      `local-combinations/searchLocalCombination`,
      { body: { storeId, text: sanitiseDots(text) } }
    );
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return null;
};

export const fetchItemsInfoFromDataService = async (
  storeId: string,
  userCountryId: string,
  articleNumber: string
) => {
  try {
    const articleNumbers = articleNumber
      .split(",")
      .map((num) => num.trim())
      .filter((num) => num !== "");
    const uniqueArticleNumbers = Array.from(new Set(articleNumbers));

    const combinationResponse =
      (await httpClient.data.get<CombinationProducts[]>(
        `local-combinations/getLocalCombinations`,
        {
          params: {
            combinationNumbers: uniqueArticleNumbers.join(","),
            storeId,
          },
        }
      )) || [];

    return combinationResponse.map((itemsInfoResponse) => ({
      name:
        itemsInfoResponse.combinationNames.find(
          (name) => name.country_code === userCountryId
        )?.combination_name || "",
      no: itemsInfoResponse.combinationNumber || "",
      type: itemsInfoResponse.combinationType || "",
      noFormatted: formatCombinationNumber(itemsInfoResponse.combinationNumber),
      description: "",
      productTypeName: "",
      paNo: "",
      hfbNo: "",
      source: "data-service",
      outgoing: false,
      smallImageUrl: "",
      imageUrl: "",
      itemsCountInCombination: itemsInfoResponse.articlesCount || 0,
      itemsInCombination: itemsInfoResponse.articleCombinations || [],
    })) as unknown as LocalCombinationItem[];
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return [];
};
